import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setQuestionRetryAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const AIMessagePopupHider = ( props ) => {

  const dispatch = useDispatch();
  const setQuestionRetry = payload => { dispatch( setQuestionRetryAction( payload ) ) };

  useEffect( () => {
    const timer = setTimeout( hideAIMessagePopup, 3000 );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  const hideAIMessagePopup = () => {
    setQuestionRetry( { isShowAIMessagePopup : false } );
  };

  return props.children || null;

};

export default AIMessagePopupHider;
